import React from "react";

const TrashIcon = ({ style, color }: { color?: string; style?: React.CSSProperties }) => {
  let c = "white";
  if (color) c = color;
  return (
    <svg
      style={{ transform: "scale(0.8)", ...style }}
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.84219 1.05261H12.1579C12.7393 1.05261 13.2106 1.52393 13.2106 2.10522V3.15783H4.78947V2.10522C4.78958 1.52393 5.2609 1.05261 5.84219 1.05261ZM3.73697 3.15794V2.10533C3.73697 0.942527 4.6795 0 5.84219 0H12.1579C13.3206 0 14.2632 0.942527 14.2632 2.10522V3.15783H17.4211C17.7117 3.15783 17.9474 3.39343 17.9474 3.68413C17.9474 3.97483 17.7117 4.21043 17.4211 4.21043H0.579038C0.288338 4.21043 0.0527344 3.97483 0.0527344 3.68413C0.0527344 3.39343 0.288338 3.15783 0.579038 3.15783H3.73697V3.15794Z"
        fill={c}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.84271 17.3691C5.55201 17.3691 5.31641 17.1334 5.31641 16.8428V8.94818C5.31641 8.65759 5.55201 8.42188 5.84271 8.42188C6.13342 8.42188 6.36902 8.65759 6.36902 8.94818V16.8428C6.36902 17.1334 6.13342 17.3691 5.84271 17.3691Z"
        fill={c}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.00091 17.3691C8.71032 17.3691 8.47461 17.1334 8.47461 16.8428V8.94818C8.47461 8.65759 8.71032 8.42188 9.00091 8.42188C9.2915 8.42188 9.52722 8.65759 9.52722 8.94818V16.8428C9.52722 17.1334 9.2915 17.3691 9.00091 17.3691Z"
        fill={c}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.1572 17.3691C11.8666 17.3691 11.6309 17.1334 11.6309 16.8428V8.94818C11.6309 8.65759 11.8666 8.42188 12.1572 8.42188C12.4478 8.42188 12.6835 8.65759 12.6835 8.94818V16.8428C12.6835 17.1334 12.4479 17.3691 12.1572 17.3691Z"
        fill={c}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.1582 18.9469V6.31537C2.1582 6.02467 2.39381 5.78906 2.68451 5.78906C2.97521 5.78906 3.21081 6.02467 3.21081 6.31537V17.8943C3.21081 18.4757 3.68213 18.9469 4.26342 18.9469H13.7371C14.3185 18.9469 14.7897 18.4757 14.7897 17.8943V6.31537C14.7897 6.02467 15.0254 5.78906 15.316 5.78906C15.6066 5.78906 15.8423 6.02467 15.8423 6.31537V18.9469C15.8423 19.5283 15.3711 19.9995 14.7897 19.9995H3.21081C2.62941 19.9996 2.1582 19.5283 2.1582 18.9469Z"
        fill={c}
      />
    </svg>
  );
};

export default TrashIcon;
